import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { initCarAnimation } from '../utils/animations';
import CarAnimation from './hero/CarAnimation';
import HeadingContainer from './hero/HeadingContainer';
import HeroHeading from './hero/HeroHeading';

const Hero = () => {
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
        registerAnimations();
    }, []);

    const registerAnimations = () => {
        initCarAnimation();
    };

    return (
        <HeadingContainer>
            <HeroHeading />
            <CarAnimation />
        </HeadingContainer>
    );
};

export default Hero;
